export const Roles = {
  ADMIN: 1,
  FREE: 2,
  PRO: 3,
  SELECT: 4,
  PRIVATE_AGENT: 4,
  SUPPLIER: 5,
  SUPPORT: 6,
  PLUS: 7,
  SALES: 8,
  BLOCKED: 9,
  USAGE_BASED_BILLING_SUBSCRIBER: 10,
  SOURCING_MANAGER: 11,
}
